import React from 'react'
import './ShowCocktailInstruction.css'
import CloseIcon from '../resources/CloseIcon.svg'

const ShowCocktailInstruction = ({ imageURL, nameDrink, instruction, ingredients, handleShowCocktailDetails }) => {
    return (
        <div className='ShowCocktailInstructionContainer'>

            <button onClick={() => handleShowCocktailDetails(0, false)}>
                <img className='closeCocktailDescription' src={CloseIcon} alt="Close_icon" />
            </button>
            <img className='imageDrink' src={imageURL} alt={nameDrink} />
            <div>
                <h1>{nameDrink}</h1>
                <ul>
                    <li key={0}>Ingredients</li>
                    {ingredients.map(ingredient => {
                        if (ingredient !== null) {
                            return <li key={ingredient}>{ingredient}
                            </li>
                            }
                        return 0
                    })}
                </ul>
                <h3>How to prepare:</h3>
                <p>{instruction}</p>
            </div>


        </div>
    )
}

export default ShowCocktailInstruction
